/* eslint-disable */

import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Grid,
  IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const DetailStoreManagement = ({ open, onClose, data = {} }) => {
  const payTypeMap = {
    'QR Code': 'QR Code ( OPS )',
    'QR Code - SCB': 'QR Code ( New OPS )',
  };

  const shouldDisplayAccountDetails =
    data && Array.isArray(data.pay_type) && data.pay_type.includes('Upload');
  const [rowCount, setRowCount] = useState([]);

  // Update rowCount when data changes
  useEffect(() => {
    if (data && data.pay_type && Array.isArray(data.pay_type)) {
      setRowCount(Array.from({ length: data.pay_type.length }, (_, i) => i));
    } else {
      setRowCount([]);
    }
  }, [data]);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          borderRadius: '15px',
          width: '100%',
          maxWidth: '950px',
        },
      }}
    >
      <DialogActions sx={{ justifyContent: 'flex-end' }}>
        <IconButton onClick={onClose} sx={{ color: '#8B8888' }}>
          <CloseIcon />
        </IconButton>
      </DialogActions>
      <DialogTitle>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            fontWeight: 'bold',
            fontSize: '20px',
            marginTop: '-20px',
          }}
        >
          รายละเอียด
        </Box>
      </DialogTitle>
      <DialogContent>
        {data && (
          <>
            <Grid
              container
              spacing={2}
              sx={{
                width: '100%',
                maxWidth: '1000px',
                marginLeft: 'auto',
                marginRight: 'auto',
                marginBottom: '18px',
              }}
            >
              {/* Store Name */}
              <Grid item xs={4} md={2} lg={1.5}>
                <div style={{ wordBreak: 'break-all', whiteSpace: 'normal' }}>
                  ชื่อร้านค้า :
                </div>
              </Grid>
              <Grid item xs={8} md={4} lg={4}>
                <div style={{ wordBreak: 'break-all', whiteSpace: 'normal' }}>
                  {data.name ? data.name : '-'}
                </div>
              </Grid>

              {/* Store Key */}
              <Grid item xs={6} md={2} lg={1.5}>
                <div style={{ wordBreak: 'break-all', whiteSpace: 'normal' }}>
                  คีย์ Cashier :
                </div>
              </Grid>
              <Grid
                item
                xs={12}
                md={4}
                lg={5}
                sx={{
                  marginTop: { xs: '-10px', md: '0' },
                }}
              >
                <div
                  style={{
                    wordBreak: 'break-all',
                    whiteSpace: 'normal',
                    marginBottom: '25px',
                  }}
                >
                  {data.key_cashier ? data.key_cashier : '-'}
                </div>
              </Grid>
              <Grid item xs={6} md={2} lg={1.5}>
                <div style={{ wordBreak: 'break-all', whiteSpace: 'normal' }}>
                  เวลาหมดอายุ :
                </div>
              </Grid>
              <Grid
                item
                xs={12}
                md={4}
                lg={4}
                sx={{
                  marginTop: { xs: '-10px', md: '0' },
                }}
              >
                <div
                  style={{
                    wordBreak: 'break-all',
                    whiteSpace: 'normal',
                    marginBottom: '25px',
                  }}
                >
                  {data.token_payment_minutes
                    ? data.token_payment_minutes
                    : '-'}
                  {'    '}
                  {'    '}
                  นาที
                </div>
              </Grid>

              <Grid item xs={6} md={2} lg={1.5}>
                <div style={{ wordBreak: 'break-all', whiteSpace: 'normal' }}>
                  Revenue :
                </div>
              </Grid>
              <Grid
                item
                xs={12}
                md={4}
                lg={5}
                sx={{
                  marginTop: { xs: '-10px', md: '0' },
                }}
              >
                <div
                  style={{
                    wordBreak: 'break-all',
                    whiteSpace: 'normal',
                    marginBottom: '25px',
                  }}
                >
                  {data.recipient_id_status[0]
                    ? data.recipient_id_status[0]
                    : '-'}
                </div>
              </Grid>

              {/* Payment Channels */}
              {rowCount.map((_, index) => (
                <Box
                  key={index} // Use index for unique key
                  sx={{
                    border: '1px solid #ddd',
                    borderRadius: '4px',
                    padding: '16px',
                    marginBottom: '16px',
                    position: 'relative',
                    width: '100%',
                  }}
                >
                  {/* Payment Channels Title */}
                  <Box
                    component="span"
                    sx={{
                      position: 'absolute',
                      top: '-12px',
                      left: '16px',
                      background: '#fff',
                      padding: '0 8px',
                      fontWeight: 'bold',
                      fontSize: '14px',
                      color: '#333',
                    }}
                  >
                    ช่องทางการชำระเงิน {index + 1}
                  </Box>

                  {/* Render payment type and key */}
                  {data.pay_type[index] && (
                    <Grid container spacing={2}>
                      <Grid item xs={7.2} md={3} lg={2.7}>
                        <div
                          style={{
                            wordBreak: 'break-all',
                            whiteSpace: 'normal',
                            marginTop: '5px',
                          }}
                        >
                          {/* Dynamic Channel Label */}
                          {`ช่องทางการชำระ ${index + 1} :`}
                        </div>
                      </Grid>
                      <Grid item xs={4.8} md={9} lg={2.7}>
                        <div
                          style={{
                            wordBreak: 'break-all',
                            whiteSpace: 'normal',
                            marginTop: '5px',
                          }}
                        >
                          {/* หาค่าจาก Object ถ้าไม่มีให้ fallback ไปหาค่าเดิม ถ้าไม่มีอีกให้แสดง '-' */}
                          {payTypeMap[data.pay_type[index]] ||
                            data.pay_type[index] ||
                            '-'}
                        </div>
                      </Grid>
                      <Grid item xs={7.2} md={3} lg={2.7}>
                        <div
                          style={{
                            wordBreak: 'break-all',
                            whiteSpace: 'normal',
                            marginTop: '5px',
                          }}
                        >
                          {/* Dynamic Channel Label */}
                          {`Recipient ID :`}
                        </div>
                      </Grid>
                      <Grid item xs={4.8} md={9} lg={2.7}>
                        <div
                          style={{
                            wordBreak: 'break-all',
                            whiteSpace: 'normal',
                            marginTop: '5px',
                          }}
                        >
                          {data.recipient_id[index] || '-'}
                        </div>
                      </Grid>

                      {data.pay_type_key[index] && (
                        <>
                          <Grid item xs={8} md={3} lg={2.7}>
                            <div
                              style={{
                                wordBreak: 'break-all',
                                whiteSpace: 'normal',
                                marginTop: '-10px',
                              }}
                            >
                              {/* Dynamic Payment Key Label */}
                              {`คีย์ช่องทางการชำระ ${index + 1} :`}
                            </div>
                          </Grid>
                          <Grid item xs={12} md={9} lg={9}>
                            <div
                              style={{
                                wordBreak: 'break-all',
                                whiteSpace: 'normal',
                                marginTop: '-10px',
                              }}
                            >
                              {data.pay_type_key[index] || '-'}
                            </div>
                          </Grid>
                        </>
                      )}

                      {/* Fee */}
                      <Grid item xs={12}>
                        <Grid container alignItems="center">
                          <Grid item xs={3} md={2.7}>
                            <div
                              style={{
                                wordBreak: 'break-all',
                                whiteSpace: 'normal',
                                marginTop: '-10px',
                              }}
                            >
                              ประเภทค่าธรรมเนียม :
                            </div>
                          </Grid>
                          <Grid item xs={3} md={3}>
                            <div
                              style={{
                                wordBreak: 'break-all',
                                whiteSpace: 'normal',
                                marginTop: '-10px',
                              }}
                            >
                              {data.fee && data.fee_type[index]
                                ? data.fee_type[index]
                                : '-'}
                            </div>
                          </Grid>

                          <Grid item xs={3} md={2.7}>
                            <div
                              style={{
                                wordBreak: 'break-all',
                                whiteSpace: 'normal',
                                marginTop: '-10px',
                              }}
                            >
                              ค่าธรรมเนียม :
                            </div>
                          </Grid>
                          <Grid item xs={3} md={3}>
                            <div
                              style={{
                                wordBreak: 'break-all',
                                whiteSpace: 'normal',
                                marginTop: '-10px',
                              }}
                            >
                              {data.fee && data.fee[index]
                                ? data.fee[index]
                                : '0'}
                            </div>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  )}
                </Box>
              ))}

              <Grid item xs={7.2} md={3} lg={2.7}>
                <div style={{ wordBreak: 'break-all', whiteSpace: 'normal' }}>
                  Image :
                </div>
              </Grid>
              <Grid item xs={4.8} md={9} lg={9}>
                <div style={{ wordBreak: 'break-all', whiteSpace: 'normal' }}>
                  {data.image ? (
                    <img
                      src={`data:image/png;base64,${data.image}`}
                      alt="uploaded image"
                      style={{
                        width: '100%',
                        height: 'auto',
                        maxWidth: '300px',
                        maxHeight: '700px',
                        objectFit: 'cover',
                        borderRadius: '8px',
                      }}
                    />
                  ) : (
                    'No image available'
                  )}
                </div>
              </Grid>
            </Grid>

            {data.etax === 'true' && (
              <>
                <Grid
                  container
                  spacing={2}
                  sx={{
                    width: '100%',
                    maxWidth: '1000px',
                    marginLeft: 'auto',
                    marginRight: 'auto',
                    marginBottom: '18px',
                    marginTop: '40px',
                  }}
                >
                  <Grid item xs={12} sm={12} md={12}>
                    <Box display="flex" alignItems="center">
                      <div
                        style={{
                          wordBreak: 'break-all',
                          whiteSpace: 'normal',
                          fontWeight: 'bold',
                          fontSize: '17px',
                        }}
                      >
                        ข้อมูลรายละเอียดใบกำกับภาษี
                      </div>
                    </Box>
                  </Grid>
                </Grid>
                <Grid
                  container
                  spacing={2}
                  sx={{
                    width: '100%',
                    maxWidth: '1000px',
                    marginLeft: 'auto',
                    marginRight: 'auto',
                    marginBottom: '18px',
                  }}
                >
                  <Grid item xs={5} md={2} lg={2}>
                    <Box display="flex" alignItems="center">
                      <div
                        style={{
                          wordBreak: 'break-all',
                          whiteSpace: 'normal',
                        }}
                      >
                        API KEY :
                      </div>
                    </Box>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    md={10}
                    lg={10}
                    sx={{
                      marginTop: { xs: '-10px', md: '0' },
                    }}
                  >
                    <Box display="flex" alignItems="center">
                      <div
                        style={{
                          wordBreak: 'break-all',
                          whiteSpace: 'normal',
                        }}
                      >
                        {data.etax_api_key ? data.etax_api_key : '-'}
                      </div>
                    </Box>
                  </Grid>
                </Grid>
                <Grid
                  container
                  spacing={2}
                  sx={{
                    width: '100%',
                    maxWidth: '1000px',
                    marginLeft: 'auto',
                    marginRight: 'auto',
                    marginBottom: '18px',
                  }}
                >
                  <Grid item xs={5} md={2} lg={2}>
                    <Box display="flex" alignItems="center">
                      <div
                        style={{
                          wordBreak: 'break-all',
                          whiteSpace: 'normal',
                        }}
                      >
                        SECRET KEY :
                      </div>
                    </Box>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    md={10}
                    lg={10}
                    sx={{
                      marginTop: { xs: '-10px', md: '0' },
                    }}
                  >
                    <Box display="flex" alignItems="center">
                      <div
                        style={{
                          wordBreak: 'break-all',
                          whiteSpace: 'normal',
                        }}
                      >
                        {data.etax_secret_key ? data.etax_secret_key : '-'}
                      </div>
                    </Box>
                  </Grid>
                </Grid>
                <Grid
                  container
                  spacing={2}
                  sx={{
                    width: '100%',
                    maxWidth: '1000px',
                    marginLeft: 'auto',
                    marginRight: 'auto',
                    marginBottom: '40px',
                  }}
                >
                  <Grid item xs={3} md={2} lg={2}>
                    <Box display="flex" alignItems="center">
                      <div
                        style={{
                          wordBreak: 'break-all',
                          whiteSpace: 'normal',
                        }}
                      >
                        TAX ID :
                      </div>
                    </Box>
                  </Grid>
                  <Grid item xs={7} md={10} lg={10}>
                    <Box display="flex" alignItems="center">
                      <div
                        style={{
                          wordBreak: 'break-all',
                          whiteSpace: 'normal',
                        }}
                      >
                        {data.etax_id ? data.etax_id : '-'}
                      </div>
                    </Box>
                  </Grid>
                </Grid>
              </>
            )}

            {/* Display account details only if any payment channel has 'Upload' */}
            {shouldDisplayAccountDetails && (
              <>
                <Grid
                  container
                  spacing={2}
                  sx={{
                    width: '100%',
                    maxWidth: '1000px',
                    marginLeft: 'auto',
                    marginRight: 'auto',
                    marginBottom: '18px',
                    marginTop: '40px',
                  }}
                >
                  <Grid item xs={12} sm={12} md={12}>
                    <Box display="flex" alignItems="center">
                      <div
                        style={{
                          wordBreak: 'break-all',
                          whiteSpace: 'normal',
                          fontWeight: 'bold',
                          fontSize: '17px',
                        }}
                      >
                        ข้อมูลรายละเอียดเลขที่บัญชี
                      </div>
                    </Box>
                  </Grid>
                </Grid>

                <Grid
                  container
                  spacing={2}
                  sx={{
                    width: '100%',
                    maxWidth: '1000px',
                    marginLeft: 'auto',
                    marginRight: 'auto',
                    marginBottom: '18px',
                  }}
                >
                  {/* Bank */}
                  <Grid item xs={4} md={2} lg={2}>
                    <Box display="flex" alignItems="center">
                      <div
                        style={{
                          wordBreak: 'break-all',
                          whiteSpace: 'normal',
                        }}
                      >
                        ธนาคาร :
                      </div>
                    </Box>
                  </Grid>
                  <Grid item xs={8} md={10} lg={10}>
                    <Box display="flex" alignItems="center">
                      <div
                        style={{
                          wordBreak: 'break-all',
                          whiteSpace: 'normal',
                        }}
                      >
                        {data.account_bank_id ? data.account_bank_id : '-'}
                      </div>
                    </Box>
                  </Grid>
                </Grid>

                {/* Account Name */}
                <Grid
                  container
                  spacing={2}
                  sx={{
                    width: '100%',
                    maxWidth: '1000px',
                    marginLeft: 'auto',
                    marginRight: 'auto',
                    marginBottom: '18px',
                  }}
                >
                  <Grid item xs={4} md={2} lg={2}>
                    <Box display="flex" alignItems="center">
                      <div
                        style={{
                          wordBreak: 'break-all',
                          whiteSpace: 'normal',
                        }}
                      >
                        ชื่อบัญชี :
                      </div>
                    </Box>
                  </Grid>
                  <Grid item xs={8} md={10} lg={10}>
                    <Box display="flex" alignItems="center">
                      <div
                        style={{
                          wordBreak: 'break-all',
                          whiteSpace: 'normal',
                        }}
                      >
                        {data.account_name ? data.account_name : '-'}
                      </div>
                    </Box>
                  </Grid>
                </Grid>

                {/* Account Number */}
                <Grid
                  container
                  spacing={2}
                  sx={{
                    width: '100%',
                    maxWidth: '1000px',
                    marginLeft: 'auto',
                    marginRight: 'auto',
                    marginBottom: '40px',
                  }}
                >
                  <Grid item xs={4} md={2} lg={2}>
                    <Box display="flex" alignItems="center">
                      <div
                        style={{
                          wordBreak: 'break-all',
                          whiteSpace: 'normal',
                        }}
                      >
                        เลขที่บัญชี :
                      </div>
                    </Box>
                  </Grid>
                  <Grid item xs={8} md={10} lg={10}>
                    <Box display="flex" alignItems="center">
                      <div
                        style={{
                          wordBreak: 'break-all',
                          whiteSpace: 'normal',
                        }}
                      >
                        {data.account_number ? data.account_number : '-'}
                      </div>
                    </Box>
                  </Grid>
                </Grid>
              </>
            )}
          </>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default DetailStoreManagement;
